import * as R from 'ramda'
import moment from 'moment-timezone'

import { REDUCER_VIRTUAL_CLONE_GET_DATA } from '../../../../../constants/reducers/widget-page-action-events';
import {store} from '../../../../../store/ProviderStore'
import graphTypes from '../../../../../constants/graph-types'
import { getDataGraphOldProvider } from '../../../../../providers/get-data-old-provider';

export const updateFilterSubparks = (id_page, subparks) => {
  return dispatch => {
    const {Dashboard} = store.getState()
    const {Envelope} = Dashboard

    const envelope = R.find(R.propEq('id', id_page))(Envelope)

    const envelopeFilter = R.assocPath(['filter', 'subparks'], subparks, envelope)
    const envelopes = Envelope.filter(elm => elm.id !== envelope.id)

    dispatch({
      type: REDUCER_VIRTUAL_CLONE_GET_DATA,
      payload: R.append(envelopeFilter, envelopes)
    })
  }
}

export const updateFilterTimeRange = (id_page, timeRange) => {
  return dispatch => {
    const {Dashboard} = store.getState()
    const {Envelope} = Dashboard

    const envelope = R.find(R.propEq('id', id_page))(Envelope)

    const envelopeFilter = R.assocPath(['filter', 'data_range'], timeRange, envelope)
    const envelopes = Envelope.filter(elm => elm.id !== envelope.id)

    dispatch({
      type: REDUCER_VIRTUAL_CLONE_GET_DATA,
      payload: R.append(envelopeFilter, envelopes)
    })
  }
}

export const toggleWidgetGlobalFilter = (id_page, id_widget) => {
  return dispatch => {
    const {Dashboard, User} = store.getState()
    const {Envelope} = Dashboard
    const {parks_info} = User

    const envelope = R.find(R.propEq('id', id_page))(Envelope)
    const envelopes = Envelope.filter(elm => elm.id !== envelope.id)

    const {widgets} = envelope

    const widget = R.find(R.propEq('id', id_widget))(widgets)
    const widgetsOthers = widgets.filter(elm => elm.id !== id_widget)

    const {data_range, subparks: subparksFilter} = widget.filter
    const subparks = R.flatten(parks_info.map(elm => elm.subparks))

    const dataRange = {
      startDate: widget.filterGlobal
        ? (data_range.startDate? data_range.startDate: moment().subtract(2, 'days').format('YYYY-MM-DD'))
        : (envelope.filter.data_range.startDate? envelope.filter.data_range.startDate: moment().subtract(2, 'days').format('YYYY-MM-DD')),
      endDate: widget.filterGlobal
        ? (data_range.endDate? data_range.endDate: moment().subtract(1, 'days').format('YYYY-MM-DD'))
        : (envelope.filter.data_range.endDate? envelope.filter.data_range.endDate: moment().subtract(1, 'days').format('YYYY-MM-DD')),
    }

    const subparksToFilter = widget.filterGlobal
      ? (subparksFilter.length > 0? subparksFilter: R.slice(1, 3, subparks))
      : (envelope.filter.subparks.length > 0? envelope.filter.subparks: R.slice(1, 3, subparks))

    const graphType = R.find(R.propEq('type', widget.type))(graphTypes)



    const params = {
      subpark: subparksToFilter.map(elm => elm.id),
      time_range: [
        dataRange.startDate,
        dataRange.endDate
      ],
      timezone: 'America/Fortaleza'
    }

    getDataGraphOldProvider(graphType.name, params)
      .then(data => {
        const widgetToggleFilter = R.assoc('filterGlobal', !widget.filterGlobal, widget)
        const widgetResult = R.assoc('data', data.result, widgetToggleFilter)
        const widgetsResult = R.append(widgetResult, widgetsOthers)
        const envelopeResult = R.assoc('widgets', widgetsResult, envelope)

        dispatch({
          type: REDUCER_VIRTUAL_CLONE_GET_DATA,
          payload: R.append(envelopeResult, envelopes)
        })
      })
      .catch(error => {
        console.error('getDataGraphOldProvider', error)
        dispatch({ type: 'ASASasdasd23e2wd', payload: {} })
      })
  }
}
